import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const DepartmentEmpServices = {

  getAllDepartment: async () => {
    try {
      const response = await axios.get(ENDPOINT.Department);
      return response.data;
    } catch (error) {
      console.error("Error fetching Department:", error.message);
      throw error;
    }
  },

  createDepartment: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Department, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Department:", error.message);
      throw error;
    }
  },

  updateDepartment: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Department}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Department:", error.message);
      throw error;
    }
  },

  deleteDepartment: async ( id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Department}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Department:", error.message);
      throw error;
    }
  },

  // rolessss...

  getAllRoles: async () => {
    try {
      const response = await axios.get(ENDPOINT.roles);
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },


  createRole: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.roles, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  updateRoles: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.roles}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  deleteRole: async ( id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.roles}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },


};
